import * as React from 'react';
import { connect } from 'react-redux';
import { getVehicleTypes } from '../../redux/actions/vehicleTypes';
import {
  Title,
  RouteWrapper,
  VehicleTypeCreateForm,
  VehicleTypeList,
} from '../../components';

interface Props {
  vehicleTypes: any;
  isFetching: boolean;
  dispatch: Function;
}

class Route extends React.Component<Props> {
  componentDidMount() {
    this.props.dispatch(getVehicleTypes());
  }

  render() {
    return (
      <RouteWrapper
        title="Vehicle Types"
        requireAuth
        requirePermission="MANAGE_VEHICLE_TYPES"
        breadcrumbs={[
          { link: '/settings', text: 'Settings' },
          { link: '/settings/vehicles', text: 'Vehicles' },
          { link: '/settings/vehicles/types', text: 'Types' },
        ]}
        loading={this.props.isFetching}
      >
        <div className="container">
          <div className="columns">
            <div className="column is-12-desktop is-7-widescreen">
              <Title>Vehicle Types</Title>
              {(!this.props.isFetching ||
                this.props.vehicleTypes.length > 0) && (
                <VehicleTypeList items={this.props.vehicleTypes} />
              )}
            </div>
            <div className="column is-12-desktop is-5-widescreen">
              <VehicleTypeCreateForm />
            </div>
          </div>
        </div>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ vehicleTypes }) => ({
  vehicleTypes: vehicleTypes.vehicleTypes,
  isFetching: vehicleTypes.isFetching,
});

export default connect(mapStateToProps)(Route);
